export default "__VITE_ASSET__C7zg6oG7__"